<template>
  <div>
    <div class="card w-100">
      <div class="card-body">
        <h5 class="card-title mb-4">Calculadora Método de Bônus</h5>
        <div class="row">
          <div class="col-12 mt-3" style="text-align:left">
            <label>Na <b>Casa de apostas:</b> </label>
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-blue" style="width: 190px;">
              <label>Odd:</label>
            </div>
            <money 
              v-model="oddBetHome" 
              v-bind="odd"
              :keyup="calculateValueForBet(oddBetHome)"
              class="form-control input-format-grey"
              style="padding-left: 200px;" 
            />
          </div>
          <div class="col-12 col-md-6 mt-3">
            <div class="button-gradient-blue" style="width: 230px;">
              <label>Valor apostado:</label>
            </div>
            <money 
              v-model="valueBetHome" 
              v-bind="money"
              class="form-control input-format-grey"
              style="padding-left: 240px;" 
            />
          </div>
          <label class="freebet-label">O Bônus freebet</label>
          <div class="col-12 mt-3" style="text-align:left">
            <label>Na <b>Betfair:</b> </label>
          </div>
          <div class="col-12 col-md-6 mt-1">
            <div class="button-gradient-yellow" style="width: 190px;">
              <label>Odd:</label>
            </div>
            <money 
              v-model="oddBetfair" 
              v-bind="odd"
              class="form-control input-format-grey"
              style="padding-left: 200px;" 
            />
          </div>
          <div class="col-12 col-md-6 mt-1">
            <div class="button-gradient-yellow" style="width: 210px;">
              <label>Comissão:</label>
            </div>
            <money 
              v-model="comission" 
              v-bind="percent"
              class="form-control input-format-grey"
              style="padding-left: 220px;" 
            />
          </div>
          <div class="col-12 col-md-6 mt-1">
            <div class="button-gradient-green" style="width: 190px;">
              <label class="text-white">Valor a apostar:</label>
            </div>
            <money 
              v-model="valueForBet" 
              v-bind="money"
              class="form-control input-format-green"
              style="padding-left: 200px;" 
            />
          </div>
          <div class="col-12 col-md-6 mt-1">
            <div class="button-gradient-green" style="width: 210px;">
              <label class="text-white">Saldo necessário:</label>
            </div>
            <money 
              v-model="limitForBet" 
              v-bind="money"
              class="form-control input-format-green"
              style="padding-left: 220px;" 
            />
          </div>
          <div class="col-6 mt-3" style="text-align:left">
            <label>Valor a Somar/Deduzir do Bônus:</label>
            <div class="mt-2">
              <div class="button-gradient-green" style="width: 205px;">
                <label class="text-white">Ganhe na Casa:</label>
              </div>
              <money 
                v-model="getValueForHome" 
                v-bind="money"
                :keyup="calculateFreeBet()"
                class="form-control input-format-green"
                style="padding-left: 215px;" 
              />
            </div>
            <div class="mt-2">
              <div class="button-gradient-green" style="width: 205px;">
                <label class="text-white">Ganhe na Betfair:</label>
              </div>
              <money 
                v-model="getValueForBetfair" 
                v-bind="money"
                :keyup="calculateFreeBet()"
                class="form-control input-format-green"
                style="padding-left: 215px;" 
              />
            </div>
          </div>
          <div class="col-6 mt-3" style="text-align:left">
            <label>Conversor de Odds</label>
            <div class="mt-2">
              <div style="text-align: left;">
                <label class="conversor-odd">Fracionário:</label>
                <input type="number" v-model="odd1" :keyup="calculateOddConversorFractional(odd1)" class="form-control input-format-grey fracionario-odd1" style="background: #e9ecef;">
                <input class="form-control input-format-grey fracionario-barra" value="/" disabled style="background: #e9ecef;">
                <input type="number" v-model="odd2" class="form-control input-format-grey fracionario-odd2" style="background: #e9ecef;">
                <money 
                  v-model="oddFracResult" 
                  v-bind="odd"
                  class="form-control input-format-green input-conversor-odd"
                />
              </div>
            </div>
            <div class="mt-2">
              <div style="text-align: left;">
                <label class="conversor-americana">Americana:</label>
                <select type="number" v-model="selected" class="form-control input-format-grey americana-select" style="background: #e9ecef; top: 410px;">
                  <option value="0">+</option>
                  <option value="1">-</option>
                </select>
                <input type="number" v-model="americanaOdd" :keyup="calculateAmericanaConversor(americanaOdd)" class="form-control input-format-grey americana-odd2" style="background: #e9ecef; top: 410px;">
                <money 
                  v-model="americanaOddResult" 
                  v-bind="odd"
                  class="form-control input-format-green input-americana-odd"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  name: 'BonusCalculator',
  components: {
    Money
  },
  data () {
    return {
      oddBetHome: '',
      valueBetHome: '',
      oddBetfair: '',
      comission: '6.50',
      valueForBet: '',
      limitForBet: '',
      odd1: '',
      odd2: '',
      americanaOdd: '',
      americanaOddResult: '',
      oddFracResult: '',
      getValueForHome: '',
      getValueForBetfair: '',
      odd: {
        decimal: '.',
        prefix: '@',
        suffix: '',
        precision: 2,
        masked: false
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      percent: {
        decimal: '.',
        prefix: '',
        suffix: ' %',
        precision: 2,
        masked: false
      },
      selected: '0',
      options: [
        { text: 'Back', value: 'back' },
        { text: 'Lay', value: 'lay' },
      ]
    }
  },
  methods: {
    calculateValueForBet(item) {
      this.oddBetHome = item;

      this.valueForBet = ((this.valueBetHome * this.oddBetHome) / ((1 - this.comission * 0.01)+(this.oddBetfair -1) ));
      this.limitForBet = this.valueForBet * (this.oddBetfair - 1)
    },
    calculateOddConversorFractional(item) {
      this.oddFracResult = ((item / this.odd2) + 1);
    },
    calculateAmericanaConversor(item) {
      if( this.selected === '0') {
        this.americanaOddResult = (1 + item / 100);
      } else {
        this.americanaOddResult = (1 + 100 / item );
      }
    },
    calculateFreeBet() {
      this.getValueForHome = ((this.valueBetHome * (this.oddBetHome - 1)) - (this.valueForBet * (this.oddBetfair - 1)))
      this.getValueForBetfair = ((this.valueForBet * (100 - this.comission) * 0.01))
    }
  }
}
</script>

<style scoped>
.freebet-label {
  text-align: left;
  margin-left: 10px;
  margin-top: 10px;
}
.input-format-grey {
  padding-left: 200px;
}
.input-format-green {
  padding-left: 190px;
}
.conversor-odd {
  top: 370px;
  position: absolute;
  bottom: 0;
}
.conversor-americana {
  top: 420px;
  position: absolute;
  bottom: 0;
}
.input-conversor-odd {
  padding-left: 160px;
  width: 35%;
  margin-left: 100px;
  position: absolute;
}
.fracionario-odd1 {
  width: 75px;
  position: absolute;
  margin-left: 100px;
  z-index: 1;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  padding-left: 24px;
}
.fracionario-barra {
  width: 30px;
  position: absolute;
  margin-left: 150px;
  z-index: 1;
  border-radius: 0px;
  padding-left: 10px;
  border-left: 0px;
  border-right: 0px;
}
.fracionario-odd2 {
  width: 65px;
  position: absolute;
  margin-left: 180px;
  z-index: 1;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  padding-left: 10px;
  border-left: 0px;
}
.input-americana-odd {
  padding-left: 100px;
  width: 63%;
  margin-left: 160px;
  top: 46px;
  position: relative;
}
.americana-select {
  width: 55px;
  position: absolute;
  margin-left: 100px;
  padding-left: 15px;
}
.americana-odd2 {
  width: 85px;
  position: absolute;
  margin-left: 160px;
  z-index: 1;
  padding-left: 24px;
}
</style>
